import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { DispatchBoardService } from '../../../shared/services/dispatch-board.service';
import { DispatchesService } from '../../../shared/services/dispatches.service';
import { DispatchBoardSearch } from '../../../shared/models/DispatchBoardSearch';
import { GlobalsService } from '../../../shared/services/globals.service';
import { BaseMessageInfo } from '../../../shared/models/BaseMessageInfo';

@Component({
    selector: 'cp-move-dispatch',
    templateUrl: './move-dispatch.component.html',
    styleUrls: ['./move-dispatch.component.scss']
})
export class MoveDispatchComponent implements OnInit {

    constructor(private svc_globals: GlobalsService, private svc_data: DispatchBoardService, private svc_dispatches: DispatchesService) { }
    @Output() titleChild = new EventEmitter<string>();
    @Output() cancel = new EventEmitter();

    @Input() data: any;
    @Input() statusData: any;

    selectedStatus: any;
    statusChangeReturn: BaseMessageInfo;

    ngOnInit() {
        this.titleChild.emit('Change Dispatch Status');
    }

    valueChange(e) {
        this.selectedStatus = e;
    }

    moveClick() {
        //alert(this.statusData.moveDispatch.dispatchId + ' going to: ' + this.selectedStatus.statusId);
        this.svc_data.setNetworkFunction(true);
        this.svc_data.SaveDispatchStatus(this.statusData.moveDispatch.dispatchId, this.selectedStatus.statusId).subscribe(data => {
            this.statusChangeReturn = data;
            this.svc_data.setNetworkFunction(false);

            if (data.error) {
                alert('got an error back!');
            }
            this.cancel.emit(null);
        });
    }
    cancelClick() {
        this.cancel.emit(null);
    }

}
